import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import {
	CreateVideoStudioContext,
	ICreateVideoStudioContext,
} from '../createVideoStudioModalContext/createVideoStudioModalState/createVideoStudioModalContext';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, name } = useContext<ICreateVideoStudioContext>(CreateVideoStudioContext);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={style.btnWrapper}>
				<Button className={style.cancelBtn} theme="secondary" onClick={handleCancel}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={!name}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
